import { Requester } from './Requester';
import { IUser } from '../types';

export const InviteContact = async ({ contactId }: { contactId: string }): Promise<IUser | null> => {
    try {
        const response = await Requester<{ user: IUser } | null>({
            path: `contacts/${contactId}/user`,
            method: 'POST'
        });

        return response && 'user' in response ? (response.user as IUser) : null;
    } catch (e) {
        console.error('Invite contact request failed');
        return Promise.reject(e);
    }
};
